/* eslint-disable react/prop-types */
import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import styled from '@emotion/styled';
import noop from 'lodash/noop';

export const Form = ({
  children,
  id,
  name,
  onSubmit,
  onSubmitting,
  redux,
  initialValues,
  className,
  innerRef,
  validate,
  autocomplete,
  ...rest
}) => (
  <FinalForm
    id={id}
    onSubmit={onSubmit}
    subscription={{ submitting: true, pristine: true, submitError: true }}
    initialValues={initialValues}
    validate={validate}
    render={({ handleSubmit, submitting }) => {
      onSubmitting(submitting);
      return (
        <StyledForm
          id={id}
          ref={innerRef}
          className={className}
          onSubmit={handleSubmit}
          action="#"
          data-test={`form-${name}`}
          autocomplete={autocomplete ? 'on' : null}
        >
          {children}
        </StyledForm>
      );
    }}
    {...rest}
  />
);

const StyledForm = styled('form')`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
`;

Form.defaultProps = {
  id: null,
  onSubmit: noop,
  onSubmitting: noop,
  redux: false,
  autocomplete: false,
};
